// extracted by mini-css-extract-plugin
module.exports = {"alertText":"alertText--2X7SF","show":"show--10aoV","text":"text--3Uk3k","checked":"checked--3n0Yv"};